export function resolveCdnUrl(cdnUrl: string, path: string) {
  const base = cdnUrl.endsWith('/') ? cdnUrl : `${cdnUrl}/`;
  return new URL(path.replace(/^\/+/, ''), base).toString();
}
